import React from "react";
import { dashboardName } from "../../baseURL";

const Footer = () => {
  var d = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://bettrade.com/" target="_blank" rel="noreferrer">
            {dashboardName}
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
